<template>
  <div class="applyCkeck2">
    <el-form
      :model="form"
      :rules="rules"
      :validate-on-rule-change="false"
      ref="form"
      label-width="100px"
      size="small"
    >
      <div class="crumbs">
        <crumbs></crumbs>
      </div>
      <div class="guarantee" v-if="info">
        <div class="guerLeft">
          <div class="guerImgBox">
            <img :src="status[info.status].url" alt="" />
            <div>
              <i class="iconfont" :class="status[info.status].icon"></i>
              {{ info.statusTxt }}
            </div>
          </div>
        </div>
        <div class="guerRight">
          <div class="guerRightTop">
            <p>保单号：{{ info.policyNum ? info.policyNum : "暂无" }}</p>
            <p class="premium">
              保费：<span>{{ info.policyMoney }}</span>
            </p>
          </div>
          <div class="guerRightMiddle">
            <p>流水号：{{ info.numId ? info.numId : "暂无" }}</p>
            <p>保险公司：{{ info.companyName }}</p>
            <p>提交时间：{{ info.cTime }}</p>
            <p>产品名称：{{ info.plan.productName }}</p>
            <p>保障期限：{{ info.sTime }} - {{ info.eTime }}</p>
            <p>提交人：{{ info.adminName }}</p>
          </div>
          <div class="guerRightBottom">
            <el-form-item label="生效时间" prop="date" label-width="80px">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
                value-format="yyyy-MM-dd"
                v-model="form.date"
                style="width: 100%;"
                @change="getCorrectionInfo(1)"
              ></el-date-picker>
            </el-form-item>
          </div>
        </div>
      </div>
      <div class="contentBox">
        <div class="itemBox">
          <div class="bTit botTop">
            <el-form
              :inline="true"
              :model="searchForm"
              class="searchForm"
              ref="searchForm"
              label-width="80px"
              size="mini"
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入姓名">
                </el-input>
              </el-form-item>
              <el-form-item label="身份证" prop="id">
                <el-input v-model="searchForm.id" placeholder="请输入身份证">
                </el-input>
              </el-form-item>
              <el-form-item style="margin-left:20px;">
                <el-button @click="reset">重置</el-button>
              </el-form-item>
            </el-form>
            <div class="floatBox">
              <el-button size="small" :disabled="isAdd != 1" @click="add">
                添加人员
              </el-button>
              <el-button
                size="small"
                @click="down('/template/batch_check_template.xlsx')"
              >
                下载模板
              </el-button>
              <el-upload
                action="/api/upload/upload"
                name="file"
                multiple
                accept=".xlsx,.xls"
                :http-request="batchRepl"
                class="batchRepl"
                :show-file-list="false"
              >
                <el-button size="small">
                  批量替换
                </el-button>
              </el-upload>
              <!-- <el-button type="primary" size="small" @click="batchRepl">
              </el-button> -->
            </div>
          </div>
          <div class="conBox">
            <el-table
              :data="form.personList"
              style="width: 100%"
              size="mini"
              :row-class-name="tableRowClassName"
              >>
              <el-table-column type="index" label="序号" width="80">
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'personList.' + scope.$index + '.name'"
                    :rules="rules.name"
                  >
                    <el-input
                      v-model.trim="scope.row.name"
                      :disabled="scope.row.disabled"
                      placeholder="请输入姓名"
                      @change="changeCode(scope.row.id, scope)"
                    >
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="身份证号">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'personList.' + scope.$index + '.code'"
                    :rules="rules.code"
                  >
                    <el-input
                      v-model.trim="scope.row.code"
                      :disabled="scope.row.disabled"
                      @change="changeCode(scope.row.id, scope)"
                      placeholder="请输入身份证号"
                    >
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column prop="work_cate_title" label="工作类型">
              </el-table-column>
              <el-table-column label="保障期限">
                <template slot-scope="scope">
                  {{ scope.row.s_time }} -- {{ scope.row.e_time }}
                </template>
              </el-table-column>
              <el-table-column prop="money" label="保费金额" width="120">
              </el-table-column>
              <el-table-column prop="address" label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    :disabled="scope.row.isChange != 1"
                    v-if="scope.row.record_id == 0"
                    @click="replace(scope.$index)"
                  >
                    替换
                  </el-button>
                  <el-button
                    type="text"
                    size="mini"
                    v-if="scope.row.record_id == 1"
                    @click="dele(scope.$index)"
                    style="color:red"
                  >
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <p class="money">
              应缴变更保费：<span>
                {{ totalPrice }}
              </span>
            </p>
          </div>
        </div>
        <div class="btnBox">
          <el-button type="primary" size="small" @click="orderCorrection">
            下一步
          </el-button>
        </div>
      </div>
    </el-form>
    <!-- 批量替换弹窗 -->
    <el-dialog
      title="批量替换"
      :visible.sync="dialogVisible"
      width="1000px"
      @close="dialogClose"
      :close-on-click-modal="false"
    >
      <el-form
        :model="batchForm"
        :rules="batchRules"
        :validate-on-rule-change="false"
        ref="batchform"
        label-width="0"
        size="small"
      >
        <el-table :data="batchForm.list" style="width: 100%" size="mini">
          <el-table-column type="index" label="序号" width="80">
          </el-table-column>
          <el-table-column label="新增人员姓名">
            <template slot-scope="scope">
              <el-form-item
                :prop="'list.' + scope.$index + '.name'"
                :rules="batchRules.name"
              >
                <el-input
                  v-model.trim="scope.row.name"
                  :disabled="scope.row.disabled"
                  placeholder="请输入姓名"
                >
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="新增人员身份证号" width="180">
            <template slot-scope="scope">
              <el-form-item
                :prop="'list.' + scope.$index + '.code'"
                :rules="batchRules.code"
              >
                <el-input
                  v-model.trim="scope.row.code"
                  :disabled="scope.row.disabled"
                  placeholder="请输入身份证号"
                >
                </el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="新增人员操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.code != ''"
                @click="newReplace(scope.$index)"
              >
                修改
              </el-button>
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.code != ''"
                @click="newDele(scope.$index)"
                style="color:red"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column label="删减人员姓名">
            <template slot-scope="scope">
              <del>{{ scope.row.oldname }}</del>
            </template>
          </el-table-column>
          <el-table-column label="删减人员身份证号" width="180">
            <template slot-scope="scope">
              <del>{{ scope.row.oldcode }}</del>
            </template>
          </el-table-column>
          <el-table-column label="删减人员操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.oldcode != ''"
                @click="oldDele(scope.$index)"
                style="color:red"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <p class="hint">
          增加：{{ batchForm.list.length }}人；减少：
          {{ delData }} 人；不允许替换：
          {{ batchData.noChangeData.length }} 人；
        </p>
        <div class="fail" v-if="batchData.noChangeData.length > 0">
          <p v-for="(item, index) in batchData.noChangeData" :key="index">
            {{ item[0] }} —— {{ item[1] }}，不允许替换
          </p>
        </div>
        <el-button type="primary" size="small" @click="batchOk">
          确定批量替换
        </el-button>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  getOrderInfo,
  getCorrectionInfo,
  orderCorrection,
  getCorrectionPersonXls
} from "@/api/guarantee";
import verify from "@/utils/verify";
import download from "@/utils/download";
import crumbs from "@/components/common/crumbs";
import { upload } from "@/api/public";
export default {
  name: "guaDdetails",
  components: {
    crumbs
  },
  data() {
    var isId = (rule, value, callback) => {
      let val = verify.idNoFormatCheck(value);
      if (!val) {
        return callback(new Error("身份证号码不正确"));
      } else {
        let i = 0;
        this.form.personList.forEach(element => {
          if (element.code == value) {
            i++;
          }
        });
        if (i > 1) {
          return callback(new Error("身份证号码重复"));
        } else {
          callback();
        }
      }
    };
    var isId2 = (rule, value, callback) => {
      let val = verify.idNoFormatCheck(value);
      if (!val) {
        return callback(new Error("身份证号码不正确"));
      } else {
        let i = 0;
        console.log(i);
        this.batchForm.list.forEach(element => {
          if (element.code == value) {
            i++;
          }
        });
        if (i > 1) {
          return callback(new Error("身份证号码重复"));
        } else {
          callback();
        }
      }
    };
    return {
      status: {},
      numId: "",
      info: "", //订单详情
      // 设置时间
      pickerOptions: {
        disabledDate: time => {
          let _startTime = new Date(
            this.startTime.split("-").join("/")
          ).getTime();
          let _endTime = new Date(this.endTime.split("-").join("/")).getTime();
          return time.getTime() < _startTime || time.getTime() > _endTime;
        }
      },
      startTime: "", //可选生效时间范围
      endTime: "", //可选生效时间范围
      isAdd: "", //是否可增加人员  1 是  0 否
      policyMoney: "0.00", //变更保费
      premiumRule: "", //保费精准位数
      premiumSetting: "", //保费计算规则
      addNum: 0,
      copy: [], //储存原始人员清单
      form: {
        date: "",
        personList: []
      },
      rules: {
        date: [
          {
            required: true,
            message: "请选择生效日期",
            trigger: ["change", ["blur", "change"]]
          }
        ],
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback();
              } else {
                callback(new Error("姓名只可以是中文!"));
              }
            },
            trigger: ["blur", "change"]
          }
        ],
        code: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"]
          },
          { validator: isId, trigger: ["blur", "change"] }
        ]
      },
      //  搜索
      searchForm: {
        name: "",
        id: ""
      },
      // 批量识别
      dialogVisible: false,
      batchData: {
        //批量替换数据
        dataTxt: "",
        noChangeData: []
      },
      batchForm: {
        list: [
          {
            name: "",
            code: "",
            oldname: "",
            oldcode: "",
            id: "",
            disabled: true
          }
        ]
      },
      batchRules: {
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: ["blur", "change"]
          },
          {
            validator: (rule, value, callback) => {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback();
              } else {
                callback(new Error("姓名只可以是中文!"));
              }
            },
            trigger: ["blur", "change"]
          }
        ],
        code: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: ["blur", "change"]
          },
          { validator: isId2, trigger: ["blur", "change"] }
        ]
      }
    };
  },
  created() {
    this.status = this.$store.state.orderStatus;
    this.numId = this.$route.query.numId;
    this.getOrderInfo(); //获取订单详情
    this.getCorrectionInfo(); //获取批改信息
  },
  methods: {
    //获取订单详情
    getOrderInfo() {
      let that = this;
      getOrderInfo({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            // 设置title
            document.title = "申请批改--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //获取订单详情
    getCorrectionInfo(tag) {
      let that = this;
      getCorrectionInfo({ numId: this.numId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            if (tag != 1) {
              that.startTime = res.data.startTime;
              that.form.date = res.data.startTime;
              that.endTime = res.data.endTime;
              that.isAdd = res.data.isAdd;
              that.policyMoney = res.data.policyMoney;
              that.premiumSetting = res.data.premiumSetting;
              that.premiumRule = res.data.premiumRule;
              that.copy = res.data.personList;
              res.data.personList.forEach(element => {
                let _data = {
                  id: element.id,
                  change_id: 0,
                  record_id: 0,
                  name: element.name,
                  code: element.code,
                  money: element.money,
                  s_time: element.s_time,
                  e_time: element.e_time,
                  work_cate_title: element.work_cate_title,
                  isChange: element.isChange,
                  disabled: true
                };
                that.form.personList.push(_data);
              });
            } else {
              console.log(1);
              that.policyMoney = res.data.policyMoney;
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    // 下载
    down(downurl) {
      download(downurl);
    },
    // 重置
    reset(e) {
      this.$refs["searchForm"].resetFields();
    },
    // 添加人员add
    add(e) {
      console.log(e);
      let _array = [];
      let that = this;
      this.form.personList.forEach((element, index) => {
        that.$refs.form.validateField(
          "personList." + [index] + ".code",
          error => {
            if (error) {
              _array.push(error);
            }
          }
        );
      });
      if (!_array.length > 0) {
        this.form.personList.unshift({
          id: "0",
          change_id: "0",
          record_id: "1",
          name: "",
          code: "",
          money: this.unitPrice,
          s_time: "",
          e_time: "",
          work_cate_title: "",
          isChange: "",
          disabled: false
        });
        this.addNum++;
      } else {
        that.$notification.error({
          title: "错误",
          message: _array[0]
        });
      }
    },
    // 删除
    dele(e) {
      console.log(e);
      this.form.personList.splice(e, 1);
      this.addNum--;
    },
    // 替换
    replace(e) {
      console.log(e);
      this.form.personList[e].disabled = false;
    },
    // 替换时判断身份证是否修改
    changeCode(id, data) {
      for (let index = 0; index < this.copy.length; index++) {
        if (this.copy[index].id == id) {
          if (
            this.copy[index].code != data.row.code ||
            this.copy[index].name != data.row.name
          ) {
            this.form.personList[data.$index].change_id = "1";
          } else {
            this.form.personList[data.$index].change_id = "0";
          }
        }
      }
    },
    // 搜索时设置搜索内容
    tableRowClassName({ row, rowIndex }) {
      if (this.searchForm.name != "" || this.searchForm.id != "") {
        if (
          row.code == this.searchForm.id ||
          row.name == this.searchForm.name
        ) {
          return "";
        } else {
          return "noneDisplay";
        }
      }
    },
    // 批量替换
    batchRepl(e) {
      console.log(e);
      var that = this;
      let form = new FormData();
      form.append("file", e.file);
      form.append("folder", "other");
      let loadind = that.$loading({
        lock: true,
        text: "批量替换识别中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      upload(form)
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            let _data = {
              numId: that.numId,
              fileUrl: res.data.fileUrl
            };
            getCorrectionPersonXls(_data)
              .then(function(res) {
                console.log(res);
                loadind.close();
                if (res.code == 1) {
                  that.batchForm.list = [];
                  res.data.addData.forEach((element, index) => {
                    let _list = {
                      name: element[0],
                      code: element[1],
                      oldname: "",
                      oldcode: "",
                      disabled: true
                    };
                    if (res.data.delData[index]) {
                      _list.oldname = res.data.delData[index][0];
                      _list.oldcode = res.data.delData[index][1];
                    }
                    that.batchForm.list.push(_list);
                  });
                  that.batchData = res.data;
                  that.dialogVisible = true;
                } else {
                  that.$message.error(res.msg);
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          } else {
            loadind.close();
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 批量替换确定
    batchOk() {
      let that = this;
      this.$refs.batchform.validate(valid => {
        if (valid) {
          let loadind = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          that.batchForm.list.forEach(element => {
            if (element.oldcode) {
              that.form.personList.forEach(v => {
                if (v.code == element.oldcode) {
                  v.code = element.code;
                  v.name = element.name;
                  v.change_id = "1";
                  v.disabled = false;
                }
              });
            } else {
              console.log(that.form.personList[0].code);
              if (that.form.personList[0].code != "") {
                that.form.personList.unshift({
                  id: "0",
                  change_id: "0",
                  record_id: "1",
                  name: element.name,
                  code: element.code,
                  money: that.unitPrice,
                  s_time: "",
                  e_time: "",
                  work_cate_title: "",
                  isChange: "",
                  disabled: false
                });
                that.addNum++;
                console.log(that.addNum);
              } else {
                that.$set(that.form.personList[0], "code", element.code);
                that.$set(that.form.personList[0], "name", element.name);
              }
            }
          });
          loadind.close();
          that.dialogVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 关闭弹窗
    dialogClose() {
      this.dialogVisible = false;
    },
    // 修改
    newReplace(e) {
      this.batchForm.list[e].disabled = false;
    },
    // 删除新数据
    newDele(e) {
      this.batchForm.list.splice(e, 1);
    },
    // 删除旧数据
    oldDele(e) {
      this.batchForm.list[e].oldname = "";
      this.batchForm.list[e].oldcode = "";
    },
    // 下一步,申请批改
    orderCorrection() {
      let that = this;
      this.$refs.form.validate(valid => {
        if (valid) {
          let _data = {
            numId: that.numId,
            insureTime: that.form.date,
            addPerson: [],
            delPerson: []
          };
          let _del = [];
          that.form.personList.forEach(element => {
            let _add = {};
            if (element.change_id == 1) {
              _del.push(element.id);
            }
            if (element.record_id == 1 || element.change_id == 1) {
              _add.name = element.name;
              _add.idCard = element.code;
              _data.addPerson.push(_add);
            }
          });
          _del.forEach(item => {
            that.copy.forEach(v => {
              let _d = {};
              if (item == v.id) {
                _d.name = v.name;
                _d.idCard = v.code;
                _d.changeId = v.id;
                _data.delPerson.push(_d);
              }
            });
          });

          let loadind = that.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          orderCorrection(_data)
            .then(function(res) {
              console.log(res);
              loadind.close();
              if (res.code == 1) {
                that.$message.success(res.msg);
                if (res.data.nextStep == 1) {
                  that.$router.push({
                    path: "/hr/staffChange/pay",
                    query: { changeId: res.data.changeId }
                  });
                } else if (res.data.nextStep == 11) {
                  that.$router.push({
                    path: "/check/upData",
                    query: { changeId: res.data.changeId }
                  });
                } else {
                  that.$router.push({
                    path: "/hr/staffChange"
                  });
                }
              } else {
                that.$message.error(res.msg);
              }
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  },
  computed: {
    totalPrice() {
      let _Money = this.policyMoney * this.addNum;
      if (this.addNum > 0) {
        if (this.premiumRule == 1) {
          return _Money.toFixed(this.premiumSetting);
        } else if (this.premiumRule == 2) {
          if (this.premiumSetting == 2) {
            _Money = Math.ceil(_Money * 100) / 100;
            return _Money.toFixed(2);
          } else {
            _Money = Math.ceil(_Money * 10000) / 10000;
            return _Money.toFixed(4);
          }
        } else {
          if (this.premiumSetting == 2) {
            return (Math.floor(_Money * 100) / 100).toFixed(
              this.premiumSetting
            );
          } else {
            return (Math.floor(_Money * 10000) / 10000).toFixed(
              this.premiumSetting
            );
          }
        }
      } else {
        return 0;
      }
    },
    unitPrice() {
      let _Money = this.policyMoney;
      if (this.form.personList.length > 0) {
        if (this.premiumRule == 1) {
          return _Money.toFixed(this.premiumSetting);
        } else if (this.premiumRule == 2) {
          if (this.premiumSetting == 2) {
            _Money = Math.ceil(_Money * 100) / 100;
            return _Money.toFixed(2);
          } else {
            _Money = Math.ceil(_Money * 10000) / 10000;
            return _Money.toFixed(4);
          }
        } else {
          console.log(_Money);
          if (this.premiumSetting == 2) {
            return (Math.floor(_Money * 100) / 100).toFixed(
              this.premiumSetting
            );
          } else {
            return (Math.floor(_Money * 10000) / 10000).toFixed(
              this.premiumSetting
            );
          }
        }
      } else {
        return 0;
      }
    },
    //批量替换减少人员
    delData() {
      let that = this;
      let _num = 0;
      that.batchForm.list.forEach(element => {
        if (element.oldcode != "") {
          _num++;
        }
      });
      return _num;
    }
  }
};
</script>
<style lang="scss">
.applyCkeck2 {
  padding: 0 !important;
  margin-top: 15px !important;
  background: #f4f5f7 !important;
  box-shadow: none !important;
  & > .crumbs {
    margin: 0 8px;
  }
  .guarantee {
    padding: 24px 40px 10px 24px;
    background: #ffffff
      linear-gradient(
        150deg,
        #ffffff 0%,
        rgba(245, 248, 251, 0.76) 100%,
        #64dfff 100%
      );
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.11);
    border-radius: 9px 10px 5px 5px;
    margin: 15px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    .guerLeft {
      width: 72px;
      height: 72px;
      margin-right: 30px;
      .guerImgBox {
        position: relative;
        top: -24px;
        height: 100%;
        img {
          position: absolute;
          top: -15px;
          left: -16px;
        }
        & > div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          i {
            font-size: 25px;
            font-weight: 400;
            margin-top: 15px;
          }
        }
      }
    }
    .guerRight {
      width: calc(100% - 87px);
      .guerRightTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 20px;
        p {
          margin: 0;
        }
        .premium {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
          span {
            font-size: 24px;
            color: #f76a37;
          }
        }
      }
      .guerRightMiddle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        & > p {
          width: 33.33%;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
          margin: 0;
        }
      }
      .guerRightBottom {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-top: 30px;
        p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.85);
          border-radius: 15px 0px 15px 0px;
          background: #2ca063;
          padding: 2px 12px;
          margin-right: 20px;
        }
        span {
          font-weight: 300;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
  }
  .contentBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    overflow: hidden;
    & > .itemBox + .itemBox {
      border-top: 1px solid #eee;
    }
    .itemBox {
      .bTit {
        font-size: 16px;
        color: #666;
        padding: 20px;
        margin: 0;
        border-bottom: 1px solid #eee;
        .searchForm {
          display: inline-block;
          .el-form-item {
            margin-bottom: 0;
          }
        }
        .floatBox {
          float: right;
          margin-top: -2px;
          .batchRepl {
            display: inline-block;
            margin-left: 10px;
          }
          .el-button {
            border: 1px solid #2ca063;
            color: #2ca063;
          }
        }
      }
      .botTop {
        border-top: 1px solid #eee;
      }
      .conBox {
        padding: 20px 45px;
        .money {
          margin: 25px 0 0;
          font-size: 14px;
          color: #333;
          span {
            font-size: 24px;
            color: #dc3545;
          }
        }
      }
    }
    .el-table {
      .el-form-item,
      .el-form-item__content {
        margin: 0 !important;
        input {
          border-top: 0px;
          border-left: 0px;
          border-right: 0px;
          border-radius: 0;
          color: #333;
          padding-left: 0;
          border-color: #409eff;
        }
        .el-input.is-disabled .el-input__inner {
          background-color: #fff;
          border-color: #fff;
          cursor: auto;
          color: #333;
        }
      }
      .el-form-item.is-error {
        input {
          border-color: #f56c6c;
          color: #f56c6c !important;
        }
      }
      .el-table__body tr:hover > td {
        background-color: #fff;
      }
      .noneDisplay {
        display: none;
      }
      .el-button--text {
        color: #2ca063;
      }
    }
    .btnBox {
      margin: 50px;
      text-align: center;
    }
  }
  .el-dialog {
    .el-form {
      .el-table .cell {
        .el-form-item {
          margin-bottom: 0;
          .el-input__inner {
            padding: 5px;
          }
        }
        .el-form-item.is-error .el-input__inner {
          border-color: #f56c6c;
        }
      }
      .hint {
        color: #ff0000;
      }
      .fail {
        font-size: 12px;
        p {
          margin: 0;
          line-height: 20px;
        }
      }
      & > .el-button {
        display: block;
        margin: 30px auto;
      }
    }
  }
}
</style>
